module.exports = function () {
  return new Promise(function (resolve) {
    require.ensure([], function (require) {
      resolve(require("!!/Users/metabase/code/metabase-org/releases/2023-06-29-release-x.46.6/metabase-0.46.6/node_modules/babel-loader/lib/index.js??ruleSet[1].rules[0].use[0]!/Users/metabase/code/metabase-org/releases/2023-06-29-release-x.46.6/metabase-0.46.6/node_modules/source-map-loader/dist/cjs.js!/Users/metabase/code/metabase-org/releases/2023-06-29-release-x.46.6/metabase-0.46.6/frontend/src/metabase-lib/metadata/utils/ga-metadata.js"));
    });
  });
}